import { defineMessages } from "react-intl";

export const ecommerce = defineMessages({
  activeProducts: {
    id: "component.ecommerce.activeProducts",
    defaultMessage: "Prodotti attivi",
  },
  addProduct: {
    id: "component.ecommerce.addProduct",
    defaultMessage: "Aggiungi prodotto",
  },
  allProducts: {
    id: "component.ecommerce.allProducts",
    defaultMessage: "Tutti i prodotti",
  },
  burgers: {
    id: "component.ecommerce.burgers",
    defaultMessage: "Hamburger",
  },
  busy: {
    id: "component.ecommerce.busy",
    defaultMessage: "Occupato",
  },
  callList: {
    id: "component.ecommerce.callList",
    defaultMessage: "Storico chiamate",
  },
  callOutcome: {
    id: "component.ecommerce.callOutcome",
    defaultMessage: "Indica l'esito della chiamata",
  },
  callRecord: {
    id: "component.ecommerce.callRecord",
    defaultMessage: "Registra chiamata",
  },
  category: {
    id: "component.ecommerce.category",
    defaultMessage: "Categoria",
  },
  confirmed: {
    id: "component.ecommerce.confirmed",
    defaultMessage: "Confermata",
  },
  contacted: {
    id: "component.ecommerce.contacted",
    defaultMessage: "Contattato",
  },
  delayCollect: {
    id: "component.ecommerce.delayCollect",
    defaultMessage: "Posticipa l'orario di ritiro",
  },
  deleteOrder: {
    id: "component.ecommerce.deleteOrder",
    defaultMessage: "Cancella l'ordine",
  },
  deleted: {
    id: "component.ecommerce.deleted",
    defaultMessage: "Cancellato",
  },
  delivered: {
    id: "component.ecommerce.delivered",
    defaultMessage: "Consegnato",
  },
  displayPriority: {
    id: "component.ecommerce.displayPriority",
    defaultMessage: "Priorità di visualizzazione",
  },
  done: {
    id: "component.ecommerce.done",
    defaultMessage: "Eseguita",
  },
  drinks: {
    id: "component.ecommerce.drinks",
    defaultMessage: "Bevande",
  },
  dropped: {
    id: "component.ecommerce.dropped",
    defaultMessage: "Cade linea",
  },
  inactiveProducts: {
    id: "component.ecommerce.inactiveProducts",
    defaultMessage: "Prodotti inattivi",
  },
  inProgress: {
    id: "component.ecommerce.inProgress",
    defaultMessage: "In lavorazione",
  },
  item: {
    id: "component.ecommerce.item",
    defaultMessage: "Articolo",
  },
  newProduct: {
    id: "component.ecommerce.newProduct",
    defaultMessage: "Nuovo prodotto",
  },
  noAnswer: {
    id: "component.ecommerce.noAnswer",
    defaultMessage: "Non risponde",
  },
  notCollect: {
    id: "component.ecommerce.notCollect",
    defaultMessage: "Non ritirato",
  },
  openOrder: {
    id: "component.ecommerce.openOrder",
    defaultMessage: "ORDINI APERTI",
  },
  orderShort: {
    id: "component.ecommerce.orderShort",
    defaultMessage: "Ord.",
  },
  pause: {
    id: "component.ecommerce.pause",
    defaultMessage: "Pausa",
  },
  phoneContact: {
    id: "component.ecommerce.phoneContact",
    defaultMessage: "Contatta il cliente",
  },
  pizza: {
    id: "component.ecommerce.pizza",
    defaultMessage: "Pizza",
  },
  price: {
    id: "component.ecommerce.price",
    defaultMessage: "Prezzo",
  },
  products: {
    id: "component.ecommerce.products",
    defaultMessage: "Prodotti",
  },
  ready: {
    id: "component.ecommerce.ready",
    defaultMessage: "Pronto per il ritiro",
  },
  resume: {
    id: "component.ecommerce.resume",
    defaultMessage: "Riprendi",
  },
  sandwich: {
    id: "component.ecommerce.sandwich",
    defaultMessage: "Panini",
  },
  salads: {
    id: "component.ecommerce.salads",
    defaultMessage: "Insalate",
  },
  sides: {
    id: "component.ecommerce.sides",
    defaultMessage: "Contorni",
  },
  status: {
    id: "component.ecommerce.status",
    defaultMessage: "Stato",
  },
  statusBack: {
    id: "component.ecommerce.statusBack",
    defaultMessage: "Torna allo stato precedente",
  },
  statusNext: {
    id: "component.ecommerce.statusNext",
    defaultMessage: "Passa allo stato successivo",
  },
  tag: {
    id: "component.ecommerce.tag",
    defaultMessage: "Tag",
  },
  toConfirm: {
    id: "component.ecommerce.toConfirm",
    defaultMessage: "Da confermare",
  },
  toMake: {
    id: "component.ecommerce.toMake",
    defaultMessage: "Da preparare",
  },
  total: {
    id: "component.ecommerce.total",
    defaultMessage: "Totale",
  },
  unreachable: {
    id: "component.ecommerce.unreachable",
    defaultMessage: "Non raggiungibile",
  },
  visitReservation: {
    id: "ecommerce.visitReservation",
    defaultMessage: "Prenotazione della visita",
  },
  reservationsDone: {
    id: "ecommerce.reservationsCompleted",
    defaultMessage: "Prenotazioni effettuate",
  },
  youHaveNoReservations: {
    id: "ecommerce.youHaveNoReservations",
    defaultMessage: "Nessuna prenotazione.",
  },
  visitorType: {
    id: "ecommerce.visitorType",
    defaultMessage: "Tipo di visitatore",
  },
  visitorGroupName: {
    id: "ecommerce.visitorGroupName",
    defaultMessage: "Nome {type}",
  },
  participantsNumber: {
    id: "ecommerce.participantsNumber",
    defaultMessage: "Numero partecipanti",
  },
  participantsNumberShort: {
    id: "ecommerce.participantsNumberShort",
    defaultMessage: "Nr. vis.",
  },
  visitLanguage: {
    id: "ecommerce.visitLanguage",
    defaultMessage: "Lingua della visita",
  },
  pullmanLength: {
    id: "ecommerce.pullmanLength",
    defaultMessage: "Lunghezza pullman (m)",
  },
  pullmanLengthMaxSize: {
    id: "ecommerce.pullmanLengthMaxSize",
    defaultMessage: "Pullman troppo lungo. Massimo 10m",
  },
  pullmanNumber: {
    id: "ecommerce.pullmanNumber",
    defaultMessage: "Numero pullman",
  },
  referrerPerson: {
    id: "ecommerce.referrerPerson",
    defaultMessage: "Persona di riferimento",
  },
  arrivalTime: {
    id: "ecommerce.arrivalTime",
    defaultMessage: "Arrivo previsto",
  },
  visitLang: {
    id: "ecommerce.visitLang",
    defaultMessage: "Lingua della visita guidata",
  },
  alertNoSelfReservation: {
    id: "ecommerce.alertNoSelfReservation",
    defaultMessage:
      "Per scuole o gruppi con più di 50 persone contattare direttamente il museo.",
  },
  messageNoSelfReservation: {
    id: "ecommerce.messageNoSelfReservation",
    defaultMessage:
      "Avviso: non si effettuato prenotazioni per singoli visitatori, famiglie o piccoli gruppi* non organizzati (meno di 10 persone). Per i visitatori singoli e gruppi non organizzati l’ingresso è gratuito, è possibile lasciare un contributo volontario per sostenere le attività del Parco nazionale della pace.",
  },
  messageDisabledSlot: {
    id: "ecommerce.messageDisabledSlot",
    defaultMessage:
      "Le fasce orarie disabilitate non sono prenotabili online, ma potrebbero comunque essere disponibili: ti invitiamo a contattare il museo per verificare",
  },
  survivor: {
    id: "ecommerce.survivor",
    defaultMessage: "Richiesta presenza di un superstite",
  },
  survivorShort: {
    id: "ecommerce.survivorShort",
    defaultMessage: "Superstite",
  },
  visitDetails: {
    id: "ecommerce.visitDetails",
    defaultMessage: "Dati della visita",
  },
  groupDefinition: {
    id: "ecommerce.groupDefinition",
    defaultMessage:
      "* Per “Gruppo” si intende un gruppo organizzato, di almeno 10/15 persone, la cui visita è organizzata e gestita da Agenzie specializzate (Agenzie viaggio, Tour operator) o da Enti riconosciuti pubblici (Stato, Regioni, Comuni, ecc) o privati: non profit/Terzo Settore (Associazioni, fondazioni, comitati, Sindacati, ecc) o società.",
  },
  confirmDeleteReservation: {
    id: "ecommerce.confirmDeleteReservation",
    defaultMessage:
      "Stai per cancellare la prenotazione {name}. Confermi la cancellazione?",
  },
  askPhoneForReservation: {
    id: "ecommerce.askPhoneForReservation",
    defaultMessage:
      "Per prenotare una vista è necessario associare un numero di telefono al proprio profilo utente.",
  },
  reservationNotesInfo: {
    id: "ecommerce.reservationNotesInfo",
    defaultMessage:
      "Inserire qui le vostre note per specificare esigenze particolari o esigenze speciali di accessibilità.",
  },
  askConfirmNReservations: {
    id: "ecommerce.askConfirmNReservations",
    defaultMessage:
      "Stai per confermare {numReservations} prenotazioni. Procedi?",
  },
  askConfirm1Reservation: {
    id: "ecommerce.askConfirm1Reservation",
    defaultMessage: "Stai per confermare una prenotazione. Procedi?",
  },
  noSelectedReservationsToConfirm: {
    id: "ecommerce.noSelectedReservationsToConfirm",
    defaultMessage:
      "Nessuna delle prenotazioni che hai selezionato è da confermare",
  },
  askCancelNReservations: {
    id: "ecommerce.askCancelNReservations",
    defaultMessage:
      "Stai per annullare {numReservations} prenotazioni. Procedi?",
  },
  askCancel1Reservation: {
    id: "ecommerce.askCancel1Reservation",
    defaultMessage: "Stai per annullare una prenotazione. Procedi?",
  },
  noSelectedReservationsToCancel: {
    id: "ecommerce.noSelectedReservationsToCancel",
    defaultMessage:
      "Nessuna delle prenotazioni che hai selezionato può essere annullata",
  },
  showPastReservations: {
    id: "ecommerce.showPastReservations",
    defaultMessage: "Mostra le prenotazioni passate",
  },
  reservationIntroGroups: {
    id: "ecommerce.reservationIntroGroups",
    defaultMessage:
      "Da questa pagina è possibile prenotare una visita solamente per gruppi organizzati* inferiori a 50 persone.",
  },
  reservationIntroNoBooking: {
    id: "ecommerce.reservationIntroNoBooking",
    defaultMessage:
      "Singoli visitatori, famiglie e piccoli gruppi non organizzati possono presentarsi direttamente, senza prenotazione.",
  },
  reservationIntroVisit: {
    id: "ecommerce.reservationIntroVisit",
    defaultMessage:
      "La visita guidata è gratuita. E’ gradito un contributo volontario per sostenere le attività del Parco della pace. Ha una durata di circa 2 ore, comprensiva della visione di un filmato di ricostruzione. <br></br>Il personale vaglierà la richiesta e invierà una email di conferma all’indirizzo di posta elettronica indicato nel form di prenotazione.",
  },
  reservationIntroVehicles: {
    id: "ecommerce.reservationIntroVehicles",
    defaultMessage:
      "I mezzi per arrivare a Sant’Anna di Stazzema <u>non devono superare i dieci metri di lunghezza</u>, causa la ristrettezza della carreggiata.",
  },
  reservationIntroSchools: {
    id: "ecommerce.reservationIntroSchools",
    defaultMessage:
      "Le scuole ed i gruppi organizzati superiori alle 50 persone che intendono prenotare una visita o laboratorio devono contattare direttamente il museo.",
  },
  reservationInfoContacts: {
    id: "ecommerce.reservationInfoContacts",
    defaultMessage: "Per informazioni e prenotazioni:",
  },
  slotStartInfo: {
    id: "ecommerce.slotStartInfo",
    defaultMessage:
      "La fascia oraria indica l’orario in cui si intende cominciare la visita",
  },
  groupSubtype: {
    id: "ecommerce.groupSubtype",
    defaultMessage: "Tipo di gruppo",
  },
  groupSubtypeSpecializedAgency: {
    id: "ecommerce.groupSubtypeSpecializedAgency",
    defaultMessage: "Agenzia specializzata",
  },
  groupSubtypePublicInstitution: {
    id: "ecommerce.groupSubtypePublicInstitution",
    defaultMessage: "Ente pubblico",
  },
  groupSubtypeNonprofit: {
    id: "ecommerce.groupSubtypeNonprofit",
    defaultMessage: "Non profit/Terzo Settore",
  },
  groupSubtypeCompany: {
    id: "ecommerce.groupSubtypeCompany",
    defaultMessage: "Società",
  },
  reservationMobile: {
    id: "ecommerce.reservationMobile",
    defaultMessage: "Cellulare prenotazione",
  },
  schoolType: {
    id: "ecommerce.schoolType",
    defaultMessage: "Tipo di scuola",
  },
  schoolOrGroupType: {
    id: "ecommerce.schoolOrGroupType",
    defaultMessage: "Tipo scuola/gruppo",
  },
  classType: {
    id: "ecommerce.classType",
    defaultMessage: "Tipo di classi",
  },
  classNumber: {
    id: "ecommerce.classNumber",
    defaultMessage: "Numero di classi",
  },
  laboratories: {
    id: "ecommerce.laboratories",
    defaultMessage: "Laboratori",
  },
  schoolTypeElementary: {
    id: "ecommerce.schoolTypeElementary",
    defaultMessage: "Elementari",
  },
  schoolTypeMiddle: {
    id: "ecommerce.schoolTypeMiddle",
    defaultMessage: "Medie",
  },
  schoolTypeHigh: {
    id: "ecommerce.schoolTypeHigh",
    defaultMessage: "Superiori",
  },
  classTypeFirst: {
    id: "ecommerce.classTypeFirst",
    defaultMessage: "Prime",
  },
  classTypeSecond: {
    id: "ecommerce.classTypeSecond",
    defaultMessage: "Seconde",
  },
  classTypeThird: {
    id: "ecommerce.classTypeThird",
    defaultMessage: "Terze",
  },
  classTypeFourth: {
    id: "ecommerce.classTypeFourth",
    defaultMessage: "Quarte",
  },
  classTypeFifth: {
    id: "ecommerce.classTypeFifth",
    defaultMessage: "Quinte",
  },
  cleanFilters: {
    id: "ecommerce.cleanFilters",
    defaultMessage: "Pulisci filtri",
  },
  exportXls: {
    id: "ecommerce.exportXls",
    defaultMessage: "Esporta XLS",
  },
  closingDayWarning: {
    id: "ecommerce.closingDayWarning",
    defaultMessage:
      "La data della prenotazione coincide con un giorno di chiusura.",
  },
  showNotes: {
    id: "ecommerce.showNotes",
    defaultMessage: "Mostra note",
  },
  hideNotes: {
    id: "ecommerce.hideNotes",
    defaultMessage: "Nascondi note",
  },
  arrivalTimeRequired: {
    id: "ecommerce.arrivalTimeRequired",
    defaultMessage: "Inserisci l’orario di arrivo",
  },
});
